export const getHereMultiLineStringFromPolylines = (sections: any[]): any => {
  const lineStrings: any[] = [];

  sections.forEach((section) => {
    lineStrings.push(window.H.geo.LineString.fromFlexiblePolyline(section.polyline));
  });

  return new window.H.geo.MultiLineString(lineStrings);
};
